  
import React, {Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {CssBaseline, Typography, IconButton, Dialog,withStyles, Button, Input} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import FormGroup from '@material-ui/core/FormGroup';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import {isMobileOnly, CustomView} from 'react-device-detect';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import alertSound from './alert.mp3'

const textSize1 = () =>{
    if (isMobileOnly) return 'h5'
    else return 'h4'
  }
  
  const textSize2 = () =>{
    if (isMobileOnly) return 'h7'
    else return 'h7'
  }

 const buttonSize = () => {
   if (isMobileOnly) return 'small'
   else return 'medium'
 }

  const customWidth = (name) => {
    if (isMobileOnly) {
      if (name === 'time') return {minWidth: '30vw'}
      else if (name === 'address') return {minWidth: '36vw'}
    }
    else return {maxWidth: '10vw'}
  }

  const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    
  });

  const useCustomStyles = makeStyles({
  
      ContentBackground:{
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#282c34',
        height: '80vh',
        overflow: 'auto',
        display: 'flex',
        width:'100vw',
        textAlign: 'center',
        verticalAlign: 'middle',
        flexDirectison: 'columns',
      },

      containerStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        display: 'flex',
        textAlign: 'center',
        verticalAlign: 'middle',
        flexDirectison: 'columns',
      },
  
      title: {
        marginTop: '2vh',
        marginLeft: '2vw',
        color: 'black',
        display: 'flex',
        fontFamily:'Roboto',
        fontStyle: 'oblique',
        fontWeight: 'bold'
      },
  
  
      inputCenter: {
        textAlign: "center",
        color: "red"
      }
    });


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },

  formControl: {
    margin: theme.spacing(0.5),
    minWidth: '25vw',
  },
}));

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function SellerView({fire, soundAudio}) {
  //localStorage.removeItem('sellerAutoLogin')
 //localStorage.setItem("sellerAutoLogin", 0)
  const classes = useStyles();
  const styleClasses = useCustomStyles();
  const inputLabel = React.useRef(null)
  const [userName,setName] = React.useState('');
  const [password,setPass] = React.useState('');
  const [isChecked, setCheck] = React.useState(true)
  const [dialogCont,setCont] = React.useState([])
  const [cancelDialog,setCancel] = React.useState(false)
  const [cancelDetail,setDetail] = React.useState({
    smsNo: '',
    shopName:'',
    item:'',
    cancelList: '',
  });
  const [open,setOpen] = React.useState(false)
  const [openProduct,setOpenProduct] = React.useState(false)
  const [openDialog,setDialog] = React.useState(false)
  const [orderDialog, setOrderAlert] = React.useState(false)
  const [updateDialog, setUpdateDialog] = React.useState(false)
  const [request, setRequest] = React.useState('')
  const [isIn,setView] = React.useState(Number(localStorage.getItem('sellerAutoLogin')) || 0)
  const [tabView, setTab] = React.useState(0)
  const [customerMobileDetail, setMobileDetail] = React.useState([])
  const [sellerMenus, setMenus] = React.useState([])
  const [selectSuburb, setSelect] = React.useState('')
  const [sellerMenu,setMenu] = React.useState([])
  const [shopDescription, setShopDesc] = React.useState('');
  const [isShopOpen, setShopOpen] = React.useState('');
  const [Available, setDays] = React.useState([]);
  const [pickUp, setPick] = React.useState('N/A');
  const [shopDelivery, setDelivery] = React.useState(-1);
  const [shopMenu, setShopMenu] = React.useState([])

  const fillform = (field) => event => {
    event.preventDefault();
    if (field === 'username') setName(event.currentTarget.value);
    if (field === 'password') setPass(event.currentTarget.value);
  }

  const autoLogin = () => event => {
      event.preventDefault();
      setCheck(event.target.checked)
  }

  const logIn = () => event => {
    event.preventDefault(); 
    const dataRef = fire.database().ref('SellerLogin');
    dataRef.orderByChild('UserName').equalTo(userName).once('value',(snapshot) =>{
            let items = snapshot.val();
            for (let item in items) {
                if (items[item].Pass === password) {
                    if (isChecked) {
                      localStorage.setItem('sellerAutoLogin', 1); 
                    }
                    else localStorage.setItem('sellerAutoLogIn', 0)
                    localStorage.setItem('sellerUsername', userName);
                    localStorage.setItem('sellerPassword',password);
                    localStorage.setItem('sellerName', JSON.stringify(items[item].ShopName)); 
                    localStorage.setItem('sellerPhoneNo', items[item].PhoneNo);
                    //localStorage.setItem('sellerInfo', JSON.stringify(items[item].Suburb))
                    localStorage.setItem('sellerIndex',item)
                    localStorage.setItem('sellerType',items[item].Type)
                    setView(1)
                }
                else {
                    setName('');
                    setPass('');
                }
            }
        })
  }


  function LogInView (){
    return(
        <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="email"
            autoFocus
            value = {userName}
            onChange = {fillform('username')}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            value = {password}
            onChange = {fillform('password')}
          />
          <FormControlLabel
            control={<Checkbox checked={isChecked} onChange = {autoLogin()} value="remember" color="primary" />}
            label="Remember me"
          />
          <Button
            onClick ={logIn()}
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
        </form>
      </div>
    </Container>
    )
  }

  class OrderView extends Component  {
    constructor() {
      super();
      
    this.state = {
      container: [],
      filtercontainer: [],
      weekYears: [],
      active: -1,
    };
    }
  componentDidMount() {
      const UserName = localStorage.getItem('sellerUsername') || ''
      const PassWord = localStorage.getItem('sellerPassword') || ''
      let sellerName = JSON.parse(localStorage.getItem('sellerName'))
      const sellerType = Number(localStorage.getItem('sellerType')) || 0
      //let suburb = JSON.parse(localStorage.getItem('sellerInfo')) || ''
      const sellerRef = fire.database().ref('SellerLogin');
      const orderRef =  fire.database().ref('UserOrder');
      const menuRef = fire.database().ref('Shop')
    
    if (tabView === 2) {
        menuRef.once('value', (snapshot) => {
          let newState = [];
          let menuShop = snapshot.val();
          for (let items in sellerName) {
            let info = sellerName[items];
            for (let index in menuShop){

            if (menuShop[index].Name === info){
              newState.push({suburb: menuShop[index].Name, menu: menuShop[index], index: index})
            }
          }
        } 
        setMenus(newState)
        setView(2)
        })
    }

    sellerRef.on('value',(snapshot) =>{
      let children = snapshot.val();
      let foundSeller = false;
      for (let i in children) {
        if (children[i].Pass === PassWord && children[i].UserName === UserName) {
          localStorage.setItem('sellerName', JSON.stringify(children[i].ShopName ));
          sellerName =  children[i].ShopName 
          localStorage.setItem('sellerPhoneNo', children[i].PhoneNo);
          localStorage.setItem('sellerType', children[i].Type);
          //localStorage.setItem('sellerInfo', JSON.stringify(children[i].Suburb))
          foundSeller = true;
          break;
        }
      }
      if (!foundSeller) {
        setName('');
        setPass('');
        localStorage.removeItem('sellerUsername');
        localStorage.setItem('sellerAutoLogin', 0);
        setView(0)
      }
    })
    
    orderRef.on('value',(snapshot) => {
        let newState = [];
        let filterState = [];
        let items = snapshot.val();
        let active = this.state.active;
        for (let item in items){
          for (let element in items[item].collect){
            for (let infor in sellerName) {
              if (sellerName[infor] === items[item]['collect'][element].name) 
                      {
                          let pushObject = {
                          collect: items[item]['collect'][element].collect,
                          discount: items[item].discount,
                          location: items[item].location,
                          shopName: items[item]['collect'][element].name,
                          customerName: items[item].name,
                          phoneNo: items[item].phoneNo,
                          orderTime: items[item].orderTime,
                          payment: items[item].payment,
                          request: items[item].request || '',
                          order: items[item]['order'][sellerName[infor]],
                          orderWeek: this.getWeekNumber(new Date(items[item].orderTime))[1],
                          orderYear: this.getWeekNumber(new Date (items[item].orderTime))[0]
                          }

                          newState.push(pushObject)
                          if ( items[item]['order'][sellerName[infor]].status !== 'Cancelled' 
                          && items[item]['order'][sellerName[infor]].status !== 'Completed' ) 
                          filterState.push(pushObject)
                      }
            }
              
            } 
        }
        const groupByWeekYear = this.groupBy(['orderWeek','orderYear'])
        let stateByTime = groupByWeekYear(newState)
        let weekYears = [];
        for (let weekYear in stateByTime) {
          delete stateByTime[weekYear].orderWeek;
          delete stateByTime[weekYear].orderYear;

          const subTotal = stateByTime[weekYear].reduce(function (s, a) { 
            if (a.order.status === 'Completed') return s + Number(a.order.shopTotal)
            else return s }, 
            0)
          
          const cashTotal = stateByTime[weekYear].reduce(function (s, a) { 
            if (a.order.status === 'Completed' && a.payment === 'Cash') return s + Number(a.order.shopTotal)
            else return s }, 
            0)
          
          const promoFee = stateByTime[weekYear].reduce(function (s, a) { 
            if (a.order.status === 'Completed') return s + Number(a.order.Promo)
            else return s }, 
            0)

          let BimBimFee = 0;
          if (sellerType) {
            if (sellerType === 1 && (subTotal-promoFee) >= 100) BimBimFee = (subTotal - promoFee - 100)* 0.1;
            if (sellerType === 2) BimBimFee = (subTotal-promoFee)*0.1
            if (sellerType === 3) BimBimFee = (subTotal-promoFee)*0.05
          }
          
          weekYears.push({time: weekYear, subTotal: subTotal, promoFee: promoFee, cashTotal: cashTotal, fee: BimBimFee})
        }
        

        if (filterState.length > active && active !== -1) 
        {
          const pending = filterState.reduce(function (s,a){
            if (a.order.status === 'Pending') return s + 1
            else return s},
            0)

          if ("serviceWorker" in navigator && "PushManager" in window) this.askForPermissionToReceiveNotifications(pending);
          else if (!orderDialog) {
            soundAudio.src = alertSound
            soundAudio.play()
            setOrderAlert(true)
          }
        }

        this.setState({container: stateByTime, filtercontainer: filterState, weekYears: weekYears, active: filterState.length})

    });
  }

  askForPermissionToReceiveNotifications = async (pending) => {
    try {
      const messaging = fire.messaging();
      await messaging.requestPermission().then( () => {
        navigator.serviceWorker.getRegistration("https://bimbim-pwa.firebaseapp.com/firebase-messaging-sw.js").then((registration) => {
          const title = "BimBim"
          const options = {
            body : `You have new order. ${pending} orders are Pending`,
            icon : "https://bimbim-pwa.firebaseapp.com/bim192.png",
            requireInteraction: true 
          };
          registration.showNotification(title,options)
        });;
      });

     // return token;
    } catch(error) {console.error(error);}
  }

  getWeekNumber = (d) => {
    // Copy date so don't modify original
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
    // Get first day of year
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    // Calculate full weeks to nearest Thursday
    var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
    // Return array of year and week number
    return [d.getUTCFullYear(), weekNo];
  }

  groupBy = keys => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = keys.map(key => obj[key]).join('-');
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, []);
     
  handleClickOpen = (arg, customerName, location) => event => {
    event.preventDefault();
    const info = JSON.parse(arg);
    setRequest(info['request'])
    const maxValue = Object.keys(info).length - this.minusNo(info['Shipper'], info);
    let newState = []
    for (let i = 0; i< maxValue; i++){
      newState.push(info[i])
    }
      setCont(newState)
      setMobileDetail({
        customerName: customerName,
        location: location
      })
      setOpen(true)
  }

  productsOpen = (arg) => event => {
    event.preventDefault();
    const info = arg;
    let newState= []
    for (let items in info){
      if (info[items]['order'].status === 'Completed'){
      const maxValue = Object.keys(info[items]['order']).length - this.minusNo(info[items]['order']['Shipper'], info[items]['order']);
      for (let i = 0; i< maxValue; i++){
        let index = newState.findIndex(arg => arg.Name === info[items]['order'][i].Name);
        if (index === -1) {
          newState.push(info[items]['order'][i]); 
        }
        else {
          let newAmount = Number(newState[index].Amount) + Number(info[items]['order'][i].Amount);
          let newTotal =  Number(newState[index].Total) + Number(info[items]['order'][i].Total);
          newState[index].Amount = newAmount;
          newState[index].Total = newTotal.toFixed(2)
        }
      }
    }}
      setCont(newState)
      setOpenProduct(true)
  }

  showProducts = () => event => {
    event.preventDefault();
    const info = this.state.container;
    let newState = []
    for (let weekYear in info){
      for (let items in info[weekYear]){
        if (info[weekYear][items]['order'].status === 'Completed'){
        const maxValue = Object.keys(info[weekYear][items]['order']).length - this.minusNo(info[weekYear][items]['order']['Shipper'], info[weekYear][items]['order']);
        for (let i = 0; i< maxValue; i++){
          let index = newState.findIndex(arg => arg.Name === info[weekYear][items]['order'][i].Name);
          if (index === -1) {
            newState.push(info[weekYear][items]['order'][i]); 
          }
          else {
            let newAmount = Number(newState[index].Amount) + Number(info[weekYear][items]['order'][i].Amount);
            let newTotal =  Number(newState[index].Total) + Number(info[weekYear][items]['order'][i].Total);
            newState[index].Amount = newAmount;
            newState[index].Total = newTotal.toFixed(2)
          }
        }
      } 
    }}
      setCont(newState)
      setOpenProduct(true)
  }

  onReady = (name,orderTime,shopName, command) => event => {
    event.preventDefault();
    const orderRef =  fire.database().ref('UserOrder');
    orderRef.orderByChild('name').equalTo(name).once('value',(snapshot) => {
      let items = snapshot.val();
      for (let item in items) if (items[item].orderTime === orderTime) {
        fire.database().ref(`UserOrder/${item}/order/${shopName}`).update({status: command})
      }
    })
  }
    
  minusNo = (arg1, arg2) => { 
    if ('Promo' in arg2) {
      if (arg1) return 7
      else return 5
    }
    else {
      if (arg1) return 6
      else return 4
    }
  }

  onComplete = (name,orderTime,shopName, command, cancelList, customerNo) => event => {
    event.preventDefault();
    const orderRef =  fire.database().ref('UserOrder');

    orderRef.orderByChild('name').equalTo(name).once('value',(snapshot) => {
      let items = snapshot.val();
      for (let item in items) if (items[item].orderTime === orderTime) {
        if (command === 'Complete') fire.database().ref(`UserOrder/${item}/order/${shopName}`).update({status: 'Completed'})
        else {
          setDetail({
            smsNo: customerNo,
            shopName: shopName,
            item: item,
            cancelList: cancelList,
          })
          setCancel(true);
        }
      }
    })
  }

  sendSMS = (arg)  => {
    let sms = '';
    if (arg === 'location') sms = 'we cannot delivery to your location'
    else if (arg === 'time') sms = 'of invalid time'
    else if (arg === 'stock') sms = 'we are out of stock for your order'
    else if (arg === 'contact') sms = 'we could not contact you'
    if(navigator.userAgent.match(/Android/i)) {

      window.open(`sms:${cancelDetail.smsNo}/?body=Your order from ${cancelDetail.shopName} has been cancelled because ${sms}. If you have already made the bank transfer. Please contact email bimbimsnackoz@gmail.com with your order detail for refund`,'_blank')
        
    }
        
    if(navigator.userAgent.match(/iPhone/i)) {
        
      window.open(`sms:${cancelDetail.smsNo}&body=Your order from ${cancelDetail.shopName} has been cancelled because ${sms}. If you have already made the bank transfer. Please contact email bimbimsnackoz@gmail.com with your order detail for refund`,'_blank')
    
    }

    const cancelInfo = JSON.parse(cancelDetail.cancelList);
    const maxValue = Object.keys(cancelInfo).length - this.minusNo(cancelInfo['Shipper'], cancelInfo);

    fire.database().ref(`UserOrder/${cancelDetail.item}`).once('value', (snapshot) => {
      let items = snapshot.val();
      let newTotal = Number(items.total);
      for (let item in items['collect']){
        if (items['collect'][item].name === cancelDetail.shopName){
          newTotal = Number(items.total) - Number(items['collect'][item].fee) +  Number(items.discount) - Number(items['order'][`${cancelDetail.shopName}`].shopTotal) 
        }
      }
      fire.database().ref(`UserOrder/${cancelDetail.item}`).update({total: newTotal.toFixed(2)})
    })

    fire.database().ref(`UserOrder/${cancelDetail.item}/order/${cancelDetail.shopName}`).update({status: 'Cancelled', shopTotal: (0).toFixed(2)})

    for (let elements = 0; elements< maxValue; elements++) {
      fire.database().ref(`Seller/${cancelInfo[elements].Suburb}/${cancelInfo[elements].SellerID}/Menu/${cancelInfo[elements].ItemKey}`).once('value', (snapshot) => {
        let oldValue = Number(snapshot.val().Available);
        fire.database().ref(`Seller/${cancelInfo[elements].Suburb}/${cancelInfo[elements].SellerID}/Menu/${cancelInfo[elements].ItemKey}`).update({Available: oldValue + Number(cancelInfo[elements].Amount)})
      })
    }
  }

  handleClose = () => {setOpen(false); setOpenProduct(false)}

  processButton = (arg) => {
    if (arg === 'Pending') return 'Preparing'
    else return 'Ready'
  }

  cancelDialogClose = (arg) => event => {
      event.preventDefault();
      if (arg === 'cancel') setCancel(false) 
      else { 
      if (isMobileOnly){
        this.sendSMS(arg)
        setCancel (false)
      }
      else {
        setCancel(false)
        setDialog(true)
      }
      }
    }

    closeDialog = () => {
      setDialog(false)
    }

    closeOrderDialog = () => {
      setOrderAlert(false)
    }

    buttonDisable = (status, collect) => {
      if (status === 'Pending') return false
      else if (status === 'Preparing') return true
      else if (status === 'Ready') {
        if (collect === 'Delivery') return true
        else return false
      }
      else return true
    }

    buttonText = (status) => {
      if(status === "Pending") return 'Cancel'
      else return 'Complete'
    }

    textColor = (whatMethod, isShipper) =>{
      if (whatMethod === 'Pick-up') return 'initial'
      else {
        if (isShipper) return 'initial'
        else return 'error'
      }
    }

    tabChange = (event, newValue) => {
      event.preventDefault();
      setTab(newValue);
    };

    signOut = () => event => {
      event.preventDefault();
      setName('');
      setPass('');
      localStorage.removeItem('sellerUsername');
      localStorage.removeItem('sellerAutoLogin');
      setView(0)
    }

    a11yProps = (index) => {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

  render() {
    return (
      <div >
      
      <AppBar position="static">
        <Tabs 
        value={tabView} 
        onChange={this.tabChange} 
        aria-label="simple tabs example" 
        centered>
          <Tab label="Orders" {...this.a11yProps(0)} />
          <Tab label="History" {...this.a11yProps(1)} />
          <Tab label="Update" {...this.a11yProps(2)} />
        </Tabs>
      </AppBar>

      <p></p>
      <Button color = 'secondary' onClick = {this.signOut()} variant = 'contained'>Sign Out</Button>

      <CustomView condition = {tabView === 0}>
        <CustomView condition = {(this.state.filtercontainer.length !== 0)}>
        { this.state.filtercontainer
        .sort(function(a,b){return (new Date(a['order'].timeCollect)-((new Date(b['order'].timeCollect))))})
        .map(items => (
        <div>
          <TableContainer component={Paper}>
          <Table aria-label="simple table">
          <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell style = {customWidth()} align = 'center'>Address</TableCell>
            <TableCell  style = {customWidth()}>Time</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell align='center'>
                <Button color = 'primary' onClick = {this.handleClickOpen(JSON.stringify(items['order']))}>Detail</Button>
            </TableCell>
            <TableCell align='center'>
                <Button disabled = {this.buttonDisable(items['order'].status, items.collect)} 
                variant='contained'
                onClick= {this.onComplete(items.customerName, items.orderTime, items.shopName, this.buttonText(items['order'].status), JSON.stringify(items['order']),  items.phoneNo)}
                >
                {this.buttonText(items['order'].status)}
                </Button>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <TableRow key={items.customerName + items.orderTime}>
            <TableCell>
              <Button 
              onClick = { event => {event.preventDefault(); if (isMobileOnly) {

                if(navigator.userAgent.match(/Android/i)) {
                  window.open(`sms:${items.phoneNo}/?body=`,'_blank')
                }
  
                if(navigator.userAgent.match(/iPhone/i)) {
                  window.open(`sms:${items.phoneNo}&body=`,'_blank')
                }

                return false
              }}} 
              color = 'primary'
              size = {buttonSize()}
              >
              {items.customerName}
            </Button>
            </TableCell>
            <TableCell style = {customWidth('address')}>
              <Button 
              onClick = { event => {event.preventDefault(); window.open(`http://maps.google.com/?q=${items.location}`,"window name","location=yes,height=1000,width=1000,scrollbars=yes,status=yes,modal=yes,alwaysRaised=yes"); return false}} 
              color = 'primary'
              size = {buttonSize()}
              fullWidth = {true}
              disabled = {items.location === 'N/A'}
              >
               {items.location}
              </Button>
            </TableCell>
            <TableCell  style = {customWidth('time')}>
                {(new Date(items['order'].timeCollect)).toLocaleString()}
            </TableCell>
            <TableCell align="center">
              <Typography>
                {items['order'].status} / {items.payment}   
              </Typography>
            </TableCell>
            <TableCell align="right">
                {(Number(items['order'].shopTotal) - Number(items['order'].Promo)).toFixed(2)}
            </TableCell>
            <TableCell align= 'center'>
              <Typography color = {this.textColor(items.collect, items['order'].Shipper)}>
              {items.collect} 
              </Typography>
            </TableCell>
            <TableCell align='center'>
                <Button disabled = {items['order'].status !== 'Preparing' && items['order'].status !=='Pending'} 
                variant='contained' 
                color = 'secondary'
                onClick = {this.onReady(items.customerName, items.orderTime, items.shopName, this.processButton(items['order'].status))}
                >
                  {this.processButton(items['order'].status)}
                </Button>
            </TableCell>
            </TableRow>
         </TableBody>
      </Table>
    </TableContainer>
    <p></p>
    </div>
    ))}

    <Dialog fullScreen={isMobileOnly} onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}></DialogTitle>
          <DialogContent >
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Snack</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="right">Subtotal</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {dialogCont.map(item => (
            <TableRow key={item.Name} style={{ overflow: 'auto'}}>
            <TableCell>
                <img style ={{height: '8vh'}} src = {item.ImageLink} alt = {item.Name}/>
            </TableCell>
            <TableCell >
                {item.Name}
            </TableCell>
            <TableCell align="center">
                {item.Amount}
            </TableCell>
              <TableCell  align="right">
              <Typography>
                ${Number(item.Total).toFixed(2)}
                </Typography>
              </TableCell>
            </TableRow>
            ))}
                </TableBody>
                </Table>
            </TableContainer>
            <p></p>
            <Typography>
                {request}
            </Typography>
        </DialogContent>
      </Dialog>

      <Dialog fullWidth ='true' maxWidth = 'xs' onClose={this.cancelDialogClose('cancel')} aria-labelledby="customized-dialog-title" open={cancelDialog}>
        <DialogTitle id="customized-dialog-title" onClose={this.cancelDialogClose('cancel')}>Cancellation Reason</DialogTitle>
          <DialogContent >
            <MenuItem onClick={this.cancelDialogClose('location')}>Invalid Location</MenuItem>
            <MenuItem onClick={this.cancelDialogClose('time')}>Invalid Time</MenuItem>
            <MenuItem onClick={this.cancelDialogClose('stock')}>Out of Stock</MenuItem>
            <MenuItem onClick={this.cancelDialogClose('contact')}>Cannot Contact</MenuItem>
            <MenuItem onClick={this.cancelDialogClose('cancel')}>Back</MenuItem>
          </DialogContent>
      </Dialog>
    
      <Dialog fullWidth ='true' maxWidth = 'sm' onClose={this.closeDialog} aria-labelledby="customized-dialog-title" open={openDialog}>
        <DialogTitle id="customized-dialog-title" onClose={this.closeDialog}>Mobile Required</DialogTitle>
          <DialogContent >
            <Typography>
              Mobile Notification is required to inform customer about the cancellation. Please log in and cancel orders on your mobile device
            </Typography>
          </DialogContent>
      </Dialog>

      <Dialog fullWidth ='true' maxWidth = 'sm' onClose={this.closeOrderDialog} aria-labelledby="customized-dialog-title" open={orderDialog}>
        <DialogTitle id="customized-dialog-title" onClose={this.closeOrderDialog}>You have a new order</DialogTitle>
          <DialogContent >
            <audio ref = {React.createRef()} src={alertSound} autoPlay />
            <Typography>
              To contact customer, press on his / her name for mobile message. Mobile phone is required.
            </Typography>
          </DialogContent>
      </Dialog>
    </CustomView>

    <CustomView condition = {(this.state.filtercontainer.length === 0)} >
        <div className = {styleClasses.containerStyle}>
            <Typography variant={textSize1()}>
                You have no order at the moment
            </Typography>
        </div>
    </CustomView>
  </CustomView>


  <CustomView condition = {tabView === 1}>
    <CustomView condition = {(this.state.weekYears.length !== 0)}>
      <p></p>
      <Button color = 'primary' onClick = {this.showProducts()} variant = 'outlined'>Products Detail</Button>
        { this.state.weekYears.reverse().map(weekYear => (
        <div>
          <div style ={{backgroundColor: 'lightgray'}}>
            <Typography className={styleClasses.title} variant= {textSize2()} noWrap>
                Week {weekYear.time}
            </Typography>
          </div>
          <TableContainer component={Paper}>
          <Table aria-label="simple table">
          <TableHead>
          <TableRow>
            <TableCell>Shop</TableCell>
            <TableCell  style = {customWidth()}>Time</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Total</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.container[weekYear.time]
          .reverse()
          .sort(function(a,b){return (new Date(a['order'].timeCollect)-((new Date(b['order'].timeCollect))))}).map(items => 
            <TableRow key={items.customerName + items.orderTime}>
            <TableCell>
                {items.shopName}
            </TableCell>
            <TableCell  style = {customWidth('time')}>
                {(new Date(items['order'].timeCollect)).toLocaleString()}
            </TableCell>
            <TableCell>
              <Typography>
                {items['order'].status} / {items.payment}
              </Typography>
            </TableCell>
            <TableCell align="right">
                {Number(items['order'].shopTotal).toFixed(2)}
            </TableCell>
            <TableCell align= 'center'>
              <Typography style = {{fontStyle: 'bold'}}>
              {items.collect}
              </Typography>
            </TableCell>
            <TableCell align='center'>
                <Button color = 'primary' onClick = {this.handleClickOpen(JSON.stringify(items['order']), items.customerName, items.location)}>Detail</Button>
            </TableCell>
            </TableRow>
          )}
            <TableRow>
            <TableCell colSpan={2} />
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Subtotal:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'goldenrod', fontWeight: 'bold'}}>
                {Number(weekYear.subTotal).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} />
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Promotion:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'red', fontWeight: 'bold'}}>
                {Number(weekYear.promoFee).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>
          <TableRow>
            <TableCell align='center' colSpan={2}>
            <Button color = 'secondary' onClick = {this.productsOpen(this.state.container[weekYear.time])} variant='outlined'>Weekly Detail</Button>
            </TableCell>
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                BimBim Fee:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'red', fontWeight: 'bold'}}>
                {Number(weekYear.fee).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} />
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Cash:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'red', fontWeight: 'bold'}}>
                {Number(weekYear.cashTotal).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>
          <TableRow>
            <TableCell colSpan={2} />
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Total:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography style={{color: 'goldenrod', fontWeight: 'bold'}}>
                {(Number(weekYear.subTotal) - Number(weekYear.promoFee) - Number(weekYear.fee)- Number(weekYear.cashTotal)).toFixed(2)}
            </Typography>
            </TableCell>
            <TableCell colSpan= {2}/>
          </TableRow>
         </TableBody>
    </Table>
    </TableContainer>
    <p></p>
    </div>
    ))}
    
    <Dialog fullScreen={isMobileOnly} onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}></DialogTitle>
          <DialogContent >
            <Typography>
                Customer: {customerMobileDetail.customerName}
            </Typography>
            {
            <div>
            <Button 
              onClick = { event => {event.preventDefault(); window.open(`http://maps.google.com/?q=${customerMobileDetail.location}`,"window name","location=yes,height=1000,width=1000,scrollbars=yes,status=yes,modal=yes,alwaysRaised=yes")}} 
              color = 'primary'
              size = {buttonSize()}
              disabled = {customerMobileDetail.location === 'N/A'}
              >
              {customerMobileDetail.location}
            </Button>
            </div>
            }
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Snack</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="right">Subtotal</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {dialogCont.map(item => (
            <TableRow key={item.Name} style={{ overflow: 'auto'}}>
            <TableCell>
                <img style ={{height: '8vh'}} src = {item.ImageLink} alt = {item.Name}/>
            </TableCell>
            <TableCell >
                {item.Name}
            </TableCell>
            <TableCell align="center">
                {item.Amount}
            </TableCell>
              <TableCell  align="right">
              <Typography>
                ${Number(item.Total).toFixed(2)}
                </Typography>
              </TableCell>
            </TableRow>
            ))}
                </TableBody>
                </Table>
            </TableContainer>
            <p></p>
            <Typography>
                Request: {request}
            </Typography>
        </DialogContent>
      </Dialog>

      <Dialog fullScreen={isMobileOnly} onClose={this.handleClose} aria-labelledby="customized-dialog-title" open={openProduct}>
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}></DialogTitle>
          <DialogContent >
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Snack</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell align="center">Amount</TableCell>
                    <TableCell align="right">Subtotal</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {dialogCont.map(item => (
            <TableRow key={item.Name} style={{ overflow: 'auto'}}>
            <TableCell>
                <img style ={{height: '8vh'}} src = {item.ImageLink} alt = {item.Name}/>
            </TableCell>
            <TableCell >
                {item.Name}
            </TableCell>
            <TableCell align="center">
                {item.Amount}
            </TableCell>
              <TableCell  align="right">
              <Typography>
                ${Number(item.Total).toFixed(2)}
                </Typography>
              </TableCell>
            </TableRow>
            ))}
                </TableBody>
                </Table>
            </TableContainer>
        </DialogContent>
      </Dialog>
    </CustomView>

    <CustomView condition = {(this.state.weekYears.length === 0)} >
      <div className = {styleClasses.containerStyle}>
        <Typography variant={textSize1()}>
            You have no order history
        </Typography>
      </div>
    </CustomView>                
  </CustomView>

  <CssBaseline/>
  </div>
    )}
  }

  function Update(){

    const handleSuburb = () => event => {
      event.preventDefault();
      const selectValue = event.currentTarget.value;
      setSelect(selectValue)
      const index = sellerMenus.findIndex(arg => arg.menu.Location.Address === selectValue)
      if (index !== -1) {
        setMenu(sellerMenus[index].menu)
        setShopDesc(sellerMenus[index].menu.Description)
        setShopOpen(sellerMenus[index].menu.Open)
        setDays(sellerMenus[index].menu.AvailableDay)
        if (sellerMenus[index].menu.Method['Pick-up']){
        setPick(sellerMenus[index].menu.Method['Pick-up'].Description)
        }
        else setPick('N/A')
        if (sellerMenus[index].menu.Method['Delivery']) setDelivery(Number(sellerMenus[index].menu.Method['Delivery'].Value))
        else setDelivery(-1)
        setShopMenu(sellerMenus[index].menu.Menu)
      }
      else setMenu([])
    }

    const signOut = () => event => {
      event.preventDefault();
      setName('');
      setPass('');
      localStorage.removeItem('sellerUsername');
      localStorage.removeItem('sellerAutoLogin');
      setTab(0);
      setView(0)
    }

    const handleBack = () => event => {
      event.preventDefault();
      setTab(0)
      setView(1);
    }

    const textSize = () => {
      if (isMobileOnly) return 12
      else return 16
    }

    const fillInform = (fillType) => event => {
      event.preventDefault();
      let newValue = event.currentTarget.value;
      if (fillType === 'shopDesc') setShopDesc(newValue);
      if (fillType === 'Open') setShopOpen(newValue);
      if (fillType === 'Pick-up') setPick(newValue);
      if (fillType === 'Delivery') setDelivery(newValue);
    }

    const isOpen = (arg) => {
      if (arg === 'Yes') return 'No'
      else return 'Yes'
    }

    const handleCheck = (arg) => event => {
      if (event.target.checked === false) setDays({ ...Available, [arg]: 7 });
      else {
        if (arg === 'Mon') setDays({ ...Available, [arg]: 1 });
        if (arg === 'Tues') setDays({ ...Available, [arg]: 2 });
        if (arg === 'Wed') setDays({ ...Available, [arg]: 3 });
        if (arg === 'Thurs') setDays({ ...Available, [arg]: 4 });
        if (arg === 'Fri') setDays({ ...Available, [arg]: 5 });
        if (arg === 'Sat') setDays({ ...Available, [arg]: 6 });
        if (arg === 'Sun') setDays({ ...Available, [arg]: 0 });
      }
    }

    const updateMenu = (index, arg) => event => {
      event.preventDefault();
      let newState = shopMenu;
      let newValue = event.currentTarget.value;

    //  for (let items in shopMenu) {newState.push(shopMenu[items])}
      if (arg === 'itemDesc') newState[index].Description = newValue
      if (arg === 'itemAmount') newState[index].Available = Number(newValue)
      if (arg === 'itemPrice')  newState[index].Price = Number(newValue)
      setShopMenu(newState)
      
    }

    const imgHeight = () => {
        if (isMobileOnly) return 100
        else return 150
    }

    const customWidth = () => {
      if (isMobileOnly) return '33vw'
      else return '14vw'
    }

    const closeUpdate = () => event => setUpdateDialog(false)
    const updateShop = (arg) => event => {
      event.preventDefault();
      const menuRef = fire.database().ref('Shop')
      const index = sellerMenus.findIndex(arg => arg.menu.Location.Address === selectSuburb)

      fire.database().ref(`Shop/${sellerMenus[index].index}`).update({Description: shopDescription, Open: isShopOpen, Menu: shopMenu, AvailableDay: Available})
      if (pickUp !== "N/A"){
      fire.database().ref(`Shop/${sellerMenus[index].index}/Method/Pick-up`).update({Description: pickUp})
      }
      
      if (arg === 'all') {
       
          for (let items in sellerMenus) {
     
            //const sharedSuburb = sellerMenus[items]
            //const suburbsIndex = (sellerMenus.find(arg => arg.suburb === sharedSuburb)).index
   
         
              fire.database().ref(`Shop/${sellerMenus[items].index}`).update({Description: shopDescription, Open: isShopOpen, Menu: shopMenu, AvailableDay: Available})
              if (pickUp !== "N/A") fire.database().ref(`Shop/${sellerMenus[items].index}/Method/Pick-up`).update({Description: pickUp})
          }   
        
      }

      menuRef.once('value', (snapshot) => {
        const sellerName = JSON.parse(localStorage.getItem('sellerName')) || []
        //let suburb = JSON.parse(localStorage.getItem('sellerInfo')) || ''
        let menuShop = snapshot.val();
        let updatedState = [];
        console.log(sellerName)
        for (let items in sellerName) {
          let info = sellerName[items];
          for (let index in menuShop){
          if ((menuShop[index].Name) && menuShop[index].Name === info){
            updatedState.push({suburb: info, menu: menuShop[index], index: index})
          }
        }}
        setMenus(updatedState) 
      })
      setUpdateDialog(true)

    }

    return(
      <div>
        <p></p>
        <FormControl component="fieldset">
            <FormGroup aria-label="position" row>    
                <FormControlLabel
                  value="SignOut"
                  control={<Button color = 'primary' onClick = {handleBack()} variant = 'outlined'>Go Back</Button>}
                />

                <FormControlLabel
                  value="Back"
                  control={<Button color = 'secondary' onClick = {signOut()} variant = 'contained'>Sign Out</Button>}
                />
            </FormGroup>
        </FormControl>
        <CustomView condition = {(sellerMenus) && sellerMenus.length !== 0}>
          <p></p>
          <FormControl variant="outlined" className={classes.formControl} >
            <InputLabel ref={inputLabel} htmlFor="outlined-age-native-simple" variant = "outlined">
              Shop Address
            </InputLabel>
            <Select
              native
              textAlign = {'center'}
              value={selectSuburb}
              onChange={handleSuburb()}
              labelWidth=  {100}
              inputProps={{
                name: 'Suburb',
                id: 'outlined-age-native-simple',
                style: {fontSize: textSize() , height: 17}
              }}        
            > 
              <option value= '' />
              { sellerMenus.map(items => <option value={items.menu.Location.Address}>{items.menu.Location.Address}</option> )}
            </Select>
          </FormControl>

          <CustomView condition = {(sellerMenu) && sellerMenu.length !== 0}>
            <p/>
            <FormControl component="fieldset">
            <FormGroup aria-label="position" row>    
                <FormControlLabel
                  value="Update"
                  control={<Button color = 'primary' onClick = {updateShop('one')} variant = 'contained'>Update</Button>}
                />

                <FormControlLabel
                  value="UpdateAll"
                  control={<Button color = 'secondary' onClick = {updateShop('all')} variant = 'contained'>Update All</Button>}
                />
            </FormGroup>
            </FormControl>
            <p/>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableRow>
                  <TableCell>
                    Open
                  </TableCell>
                  <TableCell>
                    <FormControl style ={{display: 'inherit'}} >
                      <Select
                        onChange = {fillInform('Open')}
                        native
                        disableUnderline
                        inputProps={{
                          name: 'payment',
                          id: 'outlined-age-native-simple',
                      }}> 
                        <option value={sellerMenu.Open}>{sellerMenu.Open}</option>
                        <option value ={isOpen(sellerMenu.Open)}>{isOpen(sellerMenu.Open)}</option>
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    Shop Description:
                  </TableCell>
                  <TableCell>
                    <Input disableUnderline defaultValue={shopDescription} onChange={fillInform('shopDesc')} fullWidth={true} type= "text" placeholder="Your shop description" inputProps={{ 'aria-label': 'name' }} />
                  </TableCell>
                </TableRow>
                
                <TableRow>
                  <TableCell>
                    Available Days:
                  </TableCell>

                  <TableCell>
                  <FormControl component="fieldset">
                    <FormGroup aria-label="position" row>    
                      <FormControlLabel
                        value="Monday"
                        control={<Checkbox checked ={(Available) && Available['Mon'] === 1} onChange= {handleCheck('Mon')} value = 'Mon'/>}
                        label="Monday"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="Tuesday"
                        control={<Checkbox checked = {(Available) && Available['Tues'] === 2} onChange= {handleCheck('Tues')} value = 'Tues'/>}
                        label="Tuesday"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="Wednesday"
                        control={<Checkbox checked = {(Available) && Available['Wed'] === 3} onChange= {handleCheck('Wed')} value = 'Wed'/>}
                        label="Wednesday"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="Thursday"
                        control={<Checkbox checked = {(Available) && Available['Thurs'] === 4} onChange={handleCheck('Thurs')}/>}
                        label="Thursday"
                        labelPlacement="start"
                      />
                    </FormGroup>
                  </FormControl>

                  <FormControl>
                    <FormGroup aria-label="position" row>    
                      <FormControlLabel
                        value="Friday"
                        control={<Checkbox checked ={(Available) && Available['Fri'] === 5} onChange= {handleCheck('Fri')} value = 'Fri'/>}
                        label="Friday"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="Saturday"
                        control={<Checkbox checked = {(Available) && Available['Sat'] === 6} onChange= {handleCheck('Sat')} value = 'Sat'/>}
                        label="Saturday"
                        labelPlacement="start"
                      />
                      <FormControlLabel
                        value="Sunday"
                        control={<Checkbox checked = {(Available) && Available['Sun'] === 0} onChange= {handleCheck('Sun')} value = 'Sun'/>}
                        label="Sunday"
                        labelPlacement="start"
                      />
                    </FormGroup>
                  </FormControl>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    Pick-up/Delivery
                  </TableCell>

                  <TableCell>
                  <CustomView condition = {pickUp !== "N/A"}>
                  <FormControl fullWidth style ={{display: 'inherit'}}>
                    <FormGroup aria-label="position">    
                      <FormControlLabel
                        value="Pick-up"
                        control={<Input value={pickUp} onChange={fillInform('Pick-up')} fullWidth={true} type= "text" placeholder="Pick-up information" inputProps={{ 'aria-label': 'pick-up' }} />}
                      />
                    </FormGroup>
                  </FormControl>
                  </CustomView>
                    <p></p>  
                  
                  <CustomView condition = {shopDelivery !== -1}>
                  <FormControl>
                    <FormGroup aria-label="position" row>    
                      <FormControlLabel
                        value="Delivery"
                        control={<Input value={`Delivery:$${shopDelivery}`} disabled fullWidth type= "text" placeholder="Delivery information" inputProps={{ 'aria-label': 'delivery' }} />}
                      />
                      <FormControlLabel
                        value="Price"
                        control={<Input value={`${shopDelivery}`} onChange={fillInform('Delivery')} type= "Number" placeholder="Delivery price" inputProps={{ 'aria-label': 'price' }} />}
                      />
                    </FormGroup>
                  </FormControl>
                  </CustomView>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    Menu:
                  </TableCell>
                  <TableCell />
                </TableRow>
                
                { shopMenu.map(items =>
                <TableRow>
                  <TableCell>
                  <Card style= {{height: imgHeight(), maxWidth: customWidth()}}>
                  <CardMedia
                    component="img"
                    alt= {items.Name}
                    height= {imgHeight()}
                    image= {items.ImageLink}
                  />
                  </Card>
                  </TableCell>
                    
                  <TableCell>
                    <TableContainer>
                      <Table>
                        <TableRow>
                          <TableCell colSpan={2}>
                            <Input multiline disableUnderline defaultValue={items.Description} onChange={updateMenu(items['ID'], 'itemDesc')} fullWidth={true} type= "text" placeholder="Description" inputProps={{ 'aria-label': 'item description' }} />
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            Amount:
                          </TableCell>
                          <TableCell>
                            <Input defaultValue={Number(items.Available)} maxWidth={3} onChange={updateMenu(items['ID'], 'itemAmount')} type= "number" inputProps={{ 'aria-label': 'Amount' }} />
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          <TableCell>
                            Price:
                          </TableCell>
                          <TableCell>
                           <Input defaultValue={Number(items.Price)} maxWidth={5} onChange={updateMenu(items['ID'], 'itemPrice')} type= "text" inputProps={{ 'aria-label': 'Price' }} />
                          </TableCell>
                        </TableRow>
                      </Table>
                    </TableContainer>

                  </TableCell>
                </TableRow>
                )}
              </Table>
            </TableContainer>
          </CustomView>
          
          <Dialog fullWidth ='true' maxWidth = 'sm' onClose={closeUpdate()} aria-labelledby="customized-dialog-title" open={updateDialog}>
            <DialogTitle id="customized-dialog-title" onClose={closeUpdate()}>Update Succeed</DialogTitle>
            <DialogContent >
              <Typography>
                  Your shop has been updated
              </Typography>
            </DialogContent>
          </Dialog>
        </CustomView>

        <CustomView condition = {!(sellerMenus) || sellerMenus.length === 0}>
          <div className = {styleClasses.containerStyle}>
            <Typography variant={textSize1()}>
                Your shop is not set up
            </Typography>
          </div>
        </CustomView>
      </div>
    )
  }

  function renderView () {
      switch(isIn) {
      case 0: return LogInView();
      case 1: return <OrderView/>
      case 2: return Update();
      default: return false;
    }
  }

  return (renderView());
}